// eslint-disable-next-line no-unused-vars
import React, { useState, memo, useRef, useEffect } from 'react';

import useOutsideClick from 'Hooks/useOutsideClick';
import useAccount from 'Hooks/useAccount';
import useUser from 'Hooks/useUser';
import usePermissions from 'Hooks/usePermissions';
import SettingsBarComponent from 'Components/SettingsBar/SettingsBar';
import { CURRENCY_RON } from 'Constants';

const SettingsBar = memo(() => {
  const creditRef = useRef(null);
  const isCreditVisible = useOutsideClick(creditRef);
  const { data: user, isLoading: exchangeRatesLoading } = useUser();
  const { credit, creditLoading, sold, soldLoading } = useAccount();
  const { isExternalReseller } = usePermissions();
  const [menuOpen, openMenu] = useState(false);

  useEffect(() => {
    openMenu(isCreditVisible);
  }, [isCreditVisible]);

  const onClick = () => openMenu(prevState => !prevState);
  const defaultCurrency = isExternalReseller ? user?.defaultCurrency : CURRENCY_RON;

  return (
    <SettingsBarComponent
      ref={ creditRef }
      canDisplay={ user?.email && user?.loggedIn }
      dueDays={ user?.paymentDueDays }
      sold={ sold }
      exchangeRates={ user?.exchangeRates }
      exchangeRatesLoading={ exchangeRatesLoading }
      soldLoading={ soldLoading }
      credit={ credit }
      creditLoading={ creditLoading }
      menuOpen={ menuOpen }
      onToggle={ onClick }
      isExternalReseller={ isExternalReseller }
      defaultCurrency={ defaultCurrency }
      resellerName={ user?.resellerName }
    />
  );
});

SettingsBar.displayName = 'SettingsBarContainer';

export default SettingsBar;
